import { render, staticRenderFns } from "./GroupListIframe.vue?vue&type=template&id=56f70d80&"
import script from "./GroupListIframe.vue?vue&type=script&lang=ts&"
export * from "./GroupListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports